import { render, staticRenderFns } from "./view-bookings.vue?vue&type=template&id=20e06bd0&"
import script from "./view-bookings.vue?vue&type=script&lang=js&"
export * from "./view-bookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports